import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {ModalController, PopoverController} from '@ionic/angular';


@Injectable({
    providedIn: 'root'
})
export class PopupGuard implements CanDeactivate<any> {

    constructor(private popoverController: PopoverController,
                private modalController: ModalController) {
    }

    canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot): Promise<boolean> {

        return new Promise<boolean>((resolve) => {
            this.popoverController.getTop().then(
                (topmostPopover: HTMLIonPopoverElement | undefined) => {
                    if (topmostPopover) {
                        topmostPopover.dismiss();
                        resolve(false);
                    } else {
                        this.modalController.getTop().then(
                            (topmostModal: HTMLIonModalElement | undefined) => {
                                if (topmostModal) {
                                    topmostModal.dismiss();
                                    resolve(false);
                                } else resolve(true);
                            },
                            () => {
                                resolve(true);
                            });
                    }
                },
                () => {
                    resolve(true);
                });
        });
    }
}
